import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { HelperService} from '../helper.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {
  STATUS_COMPLETE,  STATUS_DELETE,
 
} from 'src/app/constants';


@Component({
  selector: 'app-my-post',
  templateUrl: './my-post.component.html',
  styleUrls: ['./my-post.component.scss']
})
export class MyPostComponent implements OnInit {

  jobListData:[];
  userID:string;
  closeResult: string;
  jobs = {
    ongoing: [],
    completed: []
  };
  mainData = {
    ongoing: [],
    completed: []
  };
  active:string;
  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private helperService:HelperService, 
    private modalService: NgbModal) { }

  ngOnInit() {

    this.userID = this.helperService.getUserID();
    if(this.userID==null){
      this.router.navigateByUrl(`login`);
    }
    else {
      this.router.navigateByUrl(`requirements`);
    }

    let jobData = {
      //token: this.helperService.studented_atob(this.helperService.getToken()),
      userID: this.helperService.studented_atob(this.helperService.getUserID()),
      hostID:this.helperService.studented_atob(this.helperService.getHostID())

    }

    this.apiService.joblist(jobData).subscribe((res:any)=>{
      
      //this.jobListData = res.data.jobListData.data;
      for (let i = 0; i < res.data.jobListData.data.length; i++) {
        const el = res.data.jobListData.data[i];
        if (el.partyStatusId != STATUS_COMPLETE && el.partyStatusId != STATUS_DELETE) {
          this.jobs['ongoing'].push(el);
          this.mainData['ongoing'].push(el);
        }
        else if (el.partyStatusId === STATUS_COMPLETE || el.partyStatusId === STATUS_DELETE) {
          this.jobs['completed'].push(el);
          this.mainData['completed'].push(el);
        }
      }
  },async err => {
     
    })
  }

  getJobNumber(jobID: number) {
    return 'SC-JOB-' + jobID.toString().padStart(8, '0');
  }
  createPost(){
    this.router.navigateByUrl(`create-post`);
  }

  open(content) {
    this.modalService.open(content,  { centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
}
